export default "__VITE_PUBLIC_ASSET__90b965a4__"